<template>
    <div class="contract-data" v-on:click="toContracts">
        <CRow>
            <CCol>
                <CWidgetBrand color="primary"
                              :right-header="gasContractCounts"
                              right-footer="contracts"
                              :left-header="volumeInGigs"
                              left-footer="Volume GWh"
                              class="w-100">
                    <CIcon name="cil-fire"
                           height="48"
                           class="my-4" />
                </CWidgetBrand>
            </CCol>
        </CRow>
    </div>
</template>

<script>
    import Vue from 'vue';
    import apis from '@/common/network';

    export default Vue.extend({
        created() {
            this.fetchContractDataGas()
        },
        data() {
            return {
                gasContractCounts: "-"
            }
        },
        //mounted() {
        //},
        methods: {
            fetchContractDataGas: function () {
                apis.protectedApi(`contract/contractGasCount/${this.$store.state.loggedInUserId}`)
                    .then(response => {
                        this.gasContractCounts = response.data.count;
                    }).catch(e => {

                    });
            },
            toContracts(args) {
                this.$router.push({ name: "Contracts", params: { utilityType: "gas" }});
            },
        },
        computed: {
            //gasContractCounts() {
            //    return this.$store.state.homeVolumeData.gasContractIds ?
            //        this.$store.state.homeVolumeData.gasContractIds.length.toLocaleString() : "-";
            //},
            volumeInGigs() {
                return this.$store.state.homeVolumeData.gasVolumeGigs ?
                    Math.round(this.$store.state.homeVolumeData.gasVolumeGigs).toLocaleString() : "-";
            }
        }
    })
</script>

<style scoped>
</style>